<script>
  import { writable } from "../localStorageStore.js";
  import { count } from "../stores.js";
  // import Sparkle from "../Sparkle.svelte";
  import confetti from "../confetti.min.js";
  import { quest } from "../taskTipStore.js";
  import { user } from "../userStore.js";
  import Monaco from "../Monaco.svelte";
  import { toHSL } from "../util.js";
  import TaskChat, { sendMessage } from "../TaskChat.svelte";
  import UserList from "./UserList.svelte";
  import TipCard from "../TipCard.svelte";
  import CheckResults from "./CheckResults.svelte";
  import CheckResultsByAllQuests from "./CheckResultsByAllQuests.svelte";

  import Icon from "fa-svelte";
  import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
  import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";

  // import { quintOut } from "svelte/easing";
  // import { crossfade } from "svelte/transition";
  // import { flip } from "svelte/animate";

  // export let prod = false;

  console.log('TeacherPage');

  if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);

// BEGIN polyfill_flatMap
if (!Array.prototype.flatMap) {
    Object.defineProperty(Array.prototype, 'flatMap', {
        value: function(callback, thisArg) {
            var self = thisArg || this;
            if (self === null) {
                throw new TypeError( 'Array.prototype.flatMap ' +
                'called on null or undefined' );
            }
            if (typeof callback !== 'function') {
                throw new TypeError( callback +
                ' is not a function');
            }

            var list = [];

            // 1. Let O be ? ToObject(this value).
            var o = Object(self);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            for (var k = 0; k < len; ++k) {
                if (k in o) {
                    var part_list = callback.call(self, o[k], k, o);
                    list = list.concat(part_list);
                }
            }

            return list;
        }
    });
}
// END polyfill_flatMap    

  $: testQuestJSON = JSON.stringify($quest, null, 2);
  $: testUserJSON = JSON.stringify($user, null, 2);


$: currentTask = $user.tasks.find(
    task => task.id == $user.currentTask
  );  

  // если у юзера есть задача с этим же id и она .done, то включить ее в результат
  // $: doneTasks = $tasks.filter(task => $userTasks.reduce((a, ut) => {ut.id === task.id && ut.done && a}));
  $: doneTasks = $user.tasks
    .filter(ut => ut.done)
    .flatMap(ut => $user.tasks.filter(t => t.id == ut.id));

  // $: checkTasks = $tasks.filter(task => task.check);
  $: checkTasks = $user.tasks
    .filter(ut => ut.check && !ut.done)
    .flatMap(ut => $user.tasks.filter(t => t.id == ut.id));

  $: notCompletedTasks = $user.tasks.filter(ut =>
    !ut.done && !ut.check && ut.open
  );

  $: inaccessibleTasks = $user.tasks.filter(
    task =>
      !doneTasks.includes(task) &&
      !checkTasks.includes(task) &&
      !notCompletedTasks.includes(task)
  );

  $: tipsForTask =
    currentTask == undefined || currentTask.tips == undefined || currentTask.tips.length <= 0
      ? []
      : currentTask.tips.flatMap(i => $user.tips.filter(tip => tip.id == i));

  $: unreadTips = $user.tips.filter(tip => !tip.viewed)
    .filter(tip => $user.tasks.find(task => task.done && task.tips && task.tips.includes(tip.id)));

  $: viewedTips = $user.tips.filter(tip => tip.viewed);

  let doneAnimation = false;

  let showEditor = false;
  function toggleEditor(e) {
    showEditor = !showEditor;
    // if (showEditor) mountEditor();
  }

  // const [send, receive] = crossfade({
  //   duration: d => Math.sqrt(d * 200),

  //   fallback(node, params) {
  //     const style = getComputedStyle(node);
  //     const transform = style.transform === "none" ? "" : style.transform;

  //     return {
  //       duration: 600,
  //       easing: quintOut,
  //       css: t => `
	// 				transform: ${transform} scale(${t});
	// 				opacity: ${t}
	// 			`
  //     };
  //   }
  // });

  function setTaskDone(task) {
    let ok = "Отлично! Зачет";
    sendMessage(ok);
    // task.link_from_student = task.link_from_student ? task.link_from_student + help : help;
    user.setTaskDone(task);
    $user.currentTask = null;

    doneAnimation = true;
    confetti.start();
    setTimeout(() => {
      doneAnimation = false;
      confetti.stop();
    }, 1000);
  }

  function setTaskCheck(task) {
    user.setTaskCheck(task);
    $user.currentTask = null;

    doneAnimation = true;
    confetti.start();
    setTimeout(() => {
      doneAnimation = false;
      confetti.stop();
    }, 1000);
  }

  function setTaskReturnToStudent(task) {
    user.setTaskReturnToStudent(task);
    $user.currentTask = null;
  }

  function setTipViewed(tip) {
    // Тичер не должен помечать просмотренными подсказки
    // tip.viewed = true;
    // user.saveTipToUser(tip);     
  }

  function selectQuest(id) {
    quest.setQuestId(id);
    console.log("$quest " + JSON.stringify($quest));
    console.log("$user.tasks " + JSON.stringify($user.tasks));

    if (!(typeof $user.tasks !== 'undefined' && $user.tasks.length > 0)) {
      // console.log("inside if");
      let task = {
        id: $quest ? $quest.startTask : -5555,
        done: false,
        check: false,
        open: true
      };
      $user.tasks = [...$user.tasks, task];
      console.log("selectQuest: " + id + " task id: " + task.id);
    }
  }

  // function selectUser(id) {
  //   user.setUserId(id);
  // }

  // let url_string = window.location.href; // "http://www.example.com/t.html?a=1&b=3&c=m2-m3-m4-m5"; //
  // let url = new URL(url_string);
  // let q = url.searchParams.get("q");
  // user.setUserId("hash111", q);
  
</script>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 840px;
    margin: 0 auto;
    top: 0px;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
    margin: 0;
  }  

  h3 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 100;
    color: #ccc;
  }

  .card.task {
    /* background-color: burlywood; */
    background-color: #fff;
  }

  /* .card.task.expanded { */
  /* background-color: {task.name != null && toHSL(task.name)}" */
  /* style="background-color: {chat.user !== $user && toHSL(chat.user)}" */
  /* } */

  .card.task.done {
    /* background-color: rgb(0, 163, 0); */
    background-color: #eee;
    /* color: #bbb; */
    box-shadow: none;
    color: transparent;
    text-shadow: 0 0 0 #bbb;
  }

  .card.task.check {
    /* background-color: hsl(143, 41%, 90%); */
    /* color: hsl(143, 34%, 54%); */
    background-color: #fff;
    /* color: #bbb; */
    color: transparent;
    text-shadow: 0 0 0 #bbb;
  }

  .card.task.inaccessible {
    /* background-color: #eee; */
    background-color: #fff;
    /* color: #ddd; */
    box-shadow: none;
    border: dotted #bbb 1px;
    color: transparent;
    text-shadow: 0 0 0 #ddd;
  }

  .card.tip {
    background-color: hsl(300, 100%, 27%);
    color: hsl(300, 100%, 67%);
  }

  .card.tip.short {
    color: #fff;
  }

  .card.tip.short.viewed {
    color: #eee;
    background-color: #aaa;
  }

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    /* transition: 0.8s; */
    transition: all 0.3s;
    display: inline-block;
    vertical-align: top;
    margin: 10px;
    max-width: 200px;
    padding: 15px;
    border-radius: 10px;
    position: relative;
  }

  .card.expanded {
    width: 100%;
    /* height: 100%; */
    position: relative;
    top: 0;
    margin-top: 0;
    left: 0;
    margin-left: 0;
    /* max-width: 60%; */
    max-width: 70%;
    /* border-radius: 20px; */
    border-radius: 20px 0px 20px 20px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);
  }

  /* On mouse-over, add a deeper shadow */
  .card:hover:not(.expanded):not(.tip):not(.inaccessible) {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    /* border-style: dashed; */
    /* background-color: #eeeeaa */
    /* background: burlywood; */
  }

  :global(.card.task.expanded) {
    /* background: burlywood; */
    /* height: 300px; */
    /* background: #0f0; */
  }
  :global(.card.tip.expanded) {
    background: #fff;
    /* height: 500px; */
  }

  /* Add some padding inside the card container */
  .container {
    /* padding: 2px 16px; */
    padding: 2px;
  }

  :global(.container.bold) {
    font-weight: bold;
    text-transform: uppercase;
    /* color: #aaa; */
    color: #333;
  }

  button.playground {
    background-color: coral;
    border: 0;
    padding: 10px;
    margin: 30px;
    border-radius: 5px;
    color: #fff;
    text-transform: uppercase;
  }

  button.done {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
    /* width: 70%; */
    /* bottom: 0px; */
  }

  button.check {
    background-color: green;
    border: 0;
    padding: 10px;
    margin: 30px;
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
  }

  button.cancel {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    left: -30px;
    bottom: -30px;
    width: 20%;
    /* bottom: 0px; */
  }

  button.close-task {
    /* background-color: green; */
    background-color: hsl(39, 60%, 80%);
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    right: -30px;
    top: -30px;
    /* width: 20%; */
    /* bottom: 0px; */
  }

  button.hidden {
    visibility: hidden;
    /* display: none; */
  }
  .left-info {
    width: 100%;
    height: 100%;
    top: 0;
    margin-top: 0;
    position: absolute;
    left: 0;
    margin-left: 0;
    border-radius: 0;
    background: #0f0;
    display: inline-block;
    padding-top: 20px;
    max-width: 200px;
  }

  :global(.myClass1) {
    /* color: red; */
    position: relative;
    top: 1px;
  }

  :global(.myClass2) {
    font-size: 14px;
  }

  /* The Modal (background) */
  .modal {
    display: hidden; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  div.hw {
    text-align: left; 
    background-color: #fff; 
    margin: 0px; 
    padding: 20px; 
    border-radius: 10px 10px 0px 0px;
  }

  input.hw {
    width: 100%;
    height: 40px;
    padding: 5px 10px;
    /* background-color: rgb(215, 215, 215); */
    line-height: 20px;
    font-size: 12px;
    /* color: rgb(136, 136, 136); */
    border-radius: 3px 3px 3px 3px;
    border: 1px solid rgb(114, 114, 114);
    box-shadow: 0 1px 0 rgba(24, 24, 24, 0.1);
    box-sizing: border-box;
  }

  .badge {
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    background-color: #777;
    border-radius: 10px;
  }

  .badge.unread {
    /* display: block; */
    position: absolute;
    top: -5px;
    left: -5px;
    background-color: red;
  }

  .badge.unread.teacher {
    position: absolute;
    top: unset;
    left: unset;
    right: -5px;
    bottom: -5px;
    background-color: rgb(153, 179, 129);
  }
  
</style>

<main>TEACHER 
<!-- {JSON.stringify($user, null, 2)} -->
<!-- {JSON.stringify($quest, null, 2)} -->
<br>
<UserList/>
{#if !$user.loading}
  <h1>{$quest.name}</h1>
  {#if $quest.name}
    <button
      on:click|preventDefault|stopPropagation={() => {user.resetCurrentQuestHistory();}}>
      resetCurrentQuestHistory
    </button>
    <br>
  {/if}
{:else}
  <h1>Подождите, пожалуйста, загружаем квест...</h1>
{/if}
  Ваш опыт: {$user.userScore}⭐️
  <br />
  <br />
  {#if $user.loading}
  Подождите, пожалуйста, загружаем квест...
  {/if}
  {#if !$user.loading && !(Array.isArray($user.tasks)&& $user.tasks.length)}
  Квест не найден<br>
  {/if}
  {#if !$user.currentTask && notCompletedTasks.length > 0}
    <h3>Выбери задачу</h3>
  {:else}
    {#if !$user.loading && notCompletedTasks.length == 0 && Array.isArray($user.tasks)&& $user.tasks.length}
      <h3>Поздравляем! Вы решили все задачи!</h3>
    {/if}
  {/if}
  {#each notCompletedTasks as task, i (task.id)}
    {#if $user.currentTask === task.id || !$user.currentTask}
      <div
        class="card task"
        on:click={() => {
          //$user.currentTask = $user.currentTask === task.id ? null : task.id;
          $user.currentTask = $user.currentTask === task.id ? task.id : task.id;
          user.resetUnreadFromStudent(task);
        }}
        class:expanded={$user.currentTask === task.id}
        style="background-color: {task.bgcolor || toHSL(task.name)}">
        <div class="container bold" class:bold={$user.currentTask === task.id}>
          {#if task.checkattemps}
            <span class="">({task.checkattemps})</span>
          {/if}                
          {task.name}
          {#if task.unreadFromStudent}
            <span class="badge unread">{task.unreadFromStudent}</span>
          {/if}    
          {#if task.unreadFromTeacher}
            <span class="badge unread teacher">{task.unreadFromTeacher}</span>
          {/if}                      
        </div>
        {#if $user.currentTask === task.id}
          <br />
          <div style="text-align: left">
          {@html task.desc}
          </div> 
          <br />
          <button
            class="playground"
            class:hidden={!task.processing}
            on:click|preventDefault|stopPropagation={() => {
              toggleEditor();
            }}>
            <i class="fas fa-chalkboard-teacher" />
            Открыть редактор кода
          </button>

          <button
            class="close-task"
            on:click|preventDefault|stopPropagation={() => {
              $user.currentTask = $user.currentTask === task.id ? null : task.id;
            }}>
            X
          </button>

          <!-- <div class="hw">
          {#if currentTask.hw}
            <div class="container bold">Сданные решения</div>
            <br>
              {#each Object.values(currentTask.hw) as hw}
              {hw}<br>
              {/each}
          {/if}
          <br />
          <label>          
          <input class="hw" bind:value={task.link_from_student} placeholder="https://вставьте сюда ссылку на выполненное задание"/>
          </label><br><br>
          </div> -->

          <!-- {#if Math.random() >= 0.5} -->
          {#if task.button == 'check'}
            <button
              class="check"
              on:click|preventDefault|stopPropagation={() => {
                setTaskCheck(task);
              }}>
              <Icon class="myClass1 myClass2" icon={faCheckSquare} />
              Отправить задачу на проверку
            </button>
          {/if}
          {#if !task.button || task.button == 'done'}
            <button
              class="done"
              on:click|preventDefault|stopPropagation={() => {
                setTaskDone(task);
              }}>
              <Icon class="myClass1 myClass2" icon={faCheckSquare} />
              Отметить задачу выполненной
            </button>
          {/if}
        {/if}
      </div>
    {/if}
  {/each}

  {#if $user.currentTask && !notCompletedTasks.includes(currentTask)}
    <div
    class="card task expanded"
    >
    <!-- style="background-color: {toHSL(task.name)}" -->
    <div class="container bold">
      {currentTask.name}
    </div>
    <br />
    <div style="text-align: left">
    {@html currentTask.desc}
    </div> 
    <!-- <br>hw:{JSON.stringify(currentTask.hw)} -->
    <!-- <br>link:{JSON.stringify(currentTask.link_from_student)} -->
    <br>
    <!-- {#if currentTask.hw}
      <div class="container bold">Сданные решения</div>
      <div style="text-align: left">
        {#each Object.values(currentTask.hw) as hw}
        {hw}<br>
        {/each}
      </div>
    {/if}
    <br /> -->
    <!-- <label>          
    <input bind:value={currentTask.link_from_student} placeholder="Ответ студенту" size="55"/>
    </label> -->

    <button
      class="close-task"
      on:click|preventDefault|stopPropagation={() => {
        $user.currentTask = $user.currentTask === currentTask.id ? null : currentTask.id;
      }}>
      X
    </button>    
    <!-- <button
      class="playground"
      on:click|preventDefault|stopPropagation={() => {
        //setTaskCheck(currentTask);
        user.setTaskOnlyReplyIntoChat(currentTask);
        currentTask.link_from_student = "";
      }}>
      <Icon class="myClass1 myClass2" icon={faCheckSquare} />
      Ответ в чат
    </button>             -->
    <button
      class="playground"
      on:click|preventDefault|stopPropagation={() => {
        //setTaskCheck(currentTask);
        setTaskReturnToStudent(currentTask);
      }}>
      <Icon class="myClass1 myClass2" icon={faCheckSquare} />
      Вернуть задачу студенту
    </button>        
    {#if currentTask.button != "done"}
      <button
        class="check"
        on:click|preventDefault|stopPropagation={() => {
          setTaskDone(currentTask);
        }}>
        <Icon class="myClass1 myClass2" icon={faCheckSquare} />
        Принять задачу
      </button>    
    {/if}
    </div>
  {/if}

  {#if checkTasks.length && !$user.currentTask}
    <br />
    <br />
    <h3>Задачи на проверке: {checkTasks.length}</h3>
    {#each checkTasks as task, i (task.id)}
      <div class="card task check"
              on:click={() => {
          user.resetUnreadFromStudent(task);
          $user.currentTask = $user.currentTask === task.id ? null : task.id;
          //$user.currentTask = $user.currentTask === task.id ? task.id : task.id;
        }}>
      {#if task.checkattemps}
        <span class="">({task.checkattemps})</span>
      {/if}      
      {task.name}
      {#if task.unreadFromStudent}
        <span class="badge unread">{task.unreadFromStudent}</span>
      {/if}      
      {#if task.unreadFromTeacher}
        <span class="badge unread teacher">{task.unreadFromTeacher}</span>
      {/if}         
      </div>
    {/each}
  {/if}

  {#if doneTasks.length && !$user.currentTask}
    <br />
    <br />
    <h3>Вы выполнили задач: {doneTasks.length}</h3>
    {#each doneTasks as task, i (task.id)}
      <div class="card task done"
              on:click={() => {
          user.resetUnreadFromStudent(task);
          $user.currentTask = $user.currentTask === task.id ? null : task.id;
          //$user.currentTask = $user.currentTask === task.id ? task.id : task.id;
        }}>
      {#if task.checkattemps}
        <span class="">({task.checkattemps})</span>
      {/if}      
      {task.name}
        {#if task.unreadFromStudent}
          <span class="badge unread">{task.unreadFromStudent}</span>
        {/if}
        {#if task.unreadFromTeacher}
          <span class="badge unread teacher">{task.unreadFromTeacher}</span>
        {/if}   
      </div>
    {/each}
  {/if}

  {#if inaccessibleTasks.length && !$user.currentTask}
    <br />
    <br />
    <h3>Пока недоступные задачи: {inaccessibleTasks.length}</h3>
    {#each inaccessibleTasks as task, i (task.id)}
      <div class="card task inaccessible">
        {#if task.checkattemps}
          <span class="">({task.checkattemps})</span>
        {/if}      
        {task.name}
          {#if task.unreadFromStudent}
            <span class="badge unread">{task.unreadFromStudent}</span>
          {/if}
          {#if task.unreadFromTeacher}
            <span class="badge unread teacher">{task.unreadFromTeacher}</span>
          {/if}             
      </div>
    {/each}
  {/if}

  <br />
  <br />
  {#if $user.currentTask}
    <br />
    {#if tipsForTask.length > 0}
      <h3>Посмотри подсказки</h3>
    {/if}
    <br />
    {#each tipsForTask as tip, i (tip.id)}
      {#if true}
        {#if $user.currentTip != tip.id}
          <div
            class="card tip short"
            class:viewed={tip.viewed}
            on:click={() => {
              $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;
            }}>
            <div
              class="container bold"
              class:bold={$user.currentTip === tip.id}>
              {tip.name}
            </div>
          </div>
        {:else}
          <div
            id="myModal"
            class="modal"
            on:click={() => {
              $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;
              setTipViewed(tip);
            }}>
            <div
              class="card tip"
              on:click|preventDefault|stopPropagation={() => {}}
              class:expanded={$user.currentTip === tip.id}>
              <i class="fas fa-book" />
              <div
                class="container bold"
                class:bold={$user.currentTip === tip.id}>
                {tip.name}
              </div>
              {#if $user.currentTip === tip.id}
                <div style="text-align: left">
                  {@html tip.desc}
                </div>
                <br />
                <br />
                {#if tip.wistia}
                  <div>
                    <iframe
                      src="https://fast.wistia.net/embed/iframe/{tip.wistia}?fullscreenButton=true&autoPlay=true"
                      allowfullscreen
                      mozallowfullscreen
                      webkitallowfullscreen
                      oallowfullscreen
                      msallowfullscreen
                      style="border: none; width: 500px; height: 250px;"
                      title="some" />
                    <!-- {#if !vimeoAvailable}
                      <div style="display: block;left: 0px; top: -200px; position: relative; color: #9b9">Видео загружается...</div>
                    {/if}   -->
                  </div>
                {/if}
                <button
                  class="close-task"
                  on:click|preventDefault|stopPropagation={() => {
                    $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;
                    tip.viewed = true;
                  }}>
                  X
                </button>
              {/if}
            </div>
          </div>
        {/if}
      {/if}
    {/each}
  {/if}
  {#if $user.currentTask}
    <br><br>
    <TaskChat bind:task={currentTask} userId={user.getUserId()} from={"teacher"}/>
  {/if}    
  
    <!-- class="close-task" -->

  {#if !$user.currentTask}
    {#if unreadTips.length > 0}
      <br />
      <br />
        <h3>Непросмотренные лекции</h3>
      <br />
      {#each unreadTips as tip, i (tip.id)}
          <TipCard bind:tip isFromTeacher={true}/>
      {/each}
    {/if}
    <!-- {@html JSON.stringify(unreadTips, null, 2)} -->

    {#if viewedTips.length > 0}
      <br />
      <br />
        <h3>Просмотренные лекции</h3>
      <br />
      {#each viewedTips as tip, i (tip.id)}
          <TipCard bind:tip isFromTeacher={true}/>
      {/each}        
    {/if}  
  {/if}    

</main>
{#if showEditor}
  <Monaco on:close={toggleEditor} />
{/if}

{#if $user.currentTask}
  <CheckResults task={currentTask} userId={user.getUserId()}/>
{/if}    

<!-- Пока не знаю, как сделать -->
<!-- {#if $user.currentTask}
  <CheckResultsByAllQuests userId={user.getUserId()}/>
{/if}     -->

<!-- {#if !prod} 
  User
  <div style="text-align: left"><pre>
  {@html testUserJSON}
  </pre></div>
  AllQuest
  <div style="text-align: left"><pre>
  {@html testQuestJSON}
  </pre></div>
{/if} -->